import { Locale } from 'date-fns';
import { ValidationErrorCause, DifferencesCause, Translation } from '../../../types';
import { DataGridHandler } from '../../DataGridFlexSales';

export interface SalesMissingsDataGridContext {
  t: Translation;
}

const initialContext: SalesMissingsDataGridContext = {
  t: () => '',
};

export default (locale: Locale) => {
  const handler = new DataGridHandler<
    DifferencesCause & ValidationErrorCause,
    SalesMissingsDataGridContext
  >(initialContext, locale);

  handler.addColumn({
    accessor: 'posNum',
    type: 'string',
    title: ({ t }) => t('missing-closing-causes.columns.pos'),
  });

  handler.addColumn({
    accessor: 'sequence',
    type: 'string',
    title: ({ t }) => t('missing-closing-causes.columns.sequence'),
  });

  handler.addColumn({
    accessor: 'closeAmt',
    type: 'number',
    title: ({ t }) => t('missing-closing-causes.columns.close-amt'),
  });

  handler.addColumn({
    accessor: 'closeGcQty',
    type: 'number',
    title: ({ t }) => t('missing-closing-causes.columns.close-gcs-qty'),
  });

  handler.addColumn({
    accessor: 'detailAmt',
    type: 'number',
    title: ({ t }) => t('missing-closing-causes.columns.detail-amt'),
  });

  handler.addColumn({
    accessor: 'detailGcQty',
    type: 'number',
    title: ({ t }) => t('missing-closing-causes.columns.detail-gc-qty'),
  });

  return handler;
};
